import { getColor } from '../../../../utils'
import { Container } from 'components'
import styled from 'styled-components'

const StyledWorkbookTerritories = styled(Container)`
  width: 100%;
  display: flex;
  flex-direction: column;
  iframe {
    width: 100%;
    min-height: 500px;
    height: 75vh;
    max-height: 80vh;
    padding: 20px 30px;
    background: rgb(251,250,255);
    border: 0;
  }
  .download-list-container {
    display: inline-block;
    flex-direction: column;
    width: 100%;
    padding-right: 18px;
  }
  .back-button {
  align-self: center;
  padding: 10px 24px;
  margin: 24px 24px; 
  max-width: 1100px;         
  width: 100%;              
  border-radius: 50px;
  background: ${getColor('brand')};
  border: 1px solid ${getColor('brand')};
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    color: ${getColor('white')};
    font-weight: 600;
  }

  .back-button:hover {
  background: ${getColor('brand')}; 
}
}

`

export default StyledWorkbookTerritories